// @flow
import * as React from 'react';
import styled from 'styled-components';
import Container from './Container';
import ButtonIcon from './ButtonIcon';

type TProps = {
  value: string,
  onChange: (value: string) => void,
};

const StyledInputSearch = styled.input`
  height: 40px;
  padding: 0 36px;
  font-family: InterMedium;
  font-size: 16px;
  width: 100%;
  border-style: hidden;
  border-radius: 4px;
`;

export default function InputSearch(props: TProps): React.Node {
  const [_value, _setValue] = React.useState(props.value || '');
  const _onChange = (name) => {
    _setValue(name);
    props.onChange(name);
  };

  return (
    <Container flex height="40px" align="center" mb={20}>
      <Container fullwidth bordered radius={4} flex align="center" relative>
        <Container flex absolute fullheight left={12} align="center">
          <ButtonIcon name="search" />
        </Container>
        <StyledInputSearch
          {...props}
          placeholder="Search"
          value={_value}
          onChange={e => _onChange(e.target.value)} />
        {props.value && (
          <Container flex absolute fullheight right={12} align="center">
            <ButtonIcon name="x-circle-fill" color="#bbb" onClick={() => _onChange('')} />
          </Container>
        )}
      </Container>
    </Container>
  );
}
